import React, { useCallback } from 'react';

import { Box, GridLegacy as Grid, TextField, Typography } from '@mui/material';

import type { BundleCabinMarkupFormRow } from '~/components/Cruises/pages/Bundles/types';

type Props = {
  rows: Array<BundleCabinMarkupFormRow>;
  onChange: (rows: Array<BundleCabinMarkupFormRow>) => void;
  disabled?: boolean;
};

function BundleCabinTypeMarkupsEditor({ rows, onChange, disabled }: Props) {
  const handleMarkupChange = useCallback(
    (cabinType: string, markupPercent: number | '') => {
      onChange(rows.map((row) => (row.cabinType === cabinType ? { ...row, markupPercent } : row)));
    },
    [rows, onChange],
  );

  return (
    <Box mt={2}>
      <Typography variant="subtitle2" gutterBottom>
        Cabin type markups
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2, maxWidth: 'lg' }}>
        Markup NET price by cabin type (0–100%). Values are stored as decimals between 0 and 1. All four cabin types are
        required.
      </Typography>
      {rows.map((row) => (
        <Grid key={row.cabinType} container spacing={2} alignItems="flex-start" sx={{ mb: 1.5 }}>
          <Grid item xs={12} sm={5}>
            <TextField fullWidth label="Cabin type" value={row.label} disabled />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              required
              fullWidth
              label="Markup (%)"
              type="number"
              value={row.markupPercent}
              onChange={(event) => {
                const { value } = event.target;
                const parsedMarkupPercent = Number(value);
                handleMarkupChange(
                  row.cabinType,
                  value === '' || Number.isNaN(parsedMarkupPercent) ? '' : parsedMarkupPercent,
                );
              }}
              disabled={disabled}
              inputProps={{ min: 0, max: 100, step: 0.1 }}
            />
          </Grid>
        </Grid>
      ))}
    </Box>
  );
}

export default BundleCabinTypeMarkupsEditor;
